module.exports = __webpack_public_path__ + "img/title.b2b2b306.png";